export enum ActionButtonEnum {
  RESUME = 'resume',
  MESSAGING = 'messaging',
  EXEMPTIONVR = 'exemptionvr',
  DOCUMENTS = 'documents',
  SIGNATURE = 'signature',
  DECISION = 'decision',
  FILEHISTORY = 'filehistory',
  DELIVERY = 'delivery',
  DUPLICATION = 'duplication',
  CANCELLATION = 'submenu-cancellation'
}

export type ActionButton = {
  label: ActionButtonEnum;
  isDisabled: boolean;
};
